module.exports = __webpack_public_path__ + "static/img/shareBtn.c8bca6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shareBtn.png
// module id = FzOG
// module chunks = 128